// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sN wu","ribbon":"sO wD","title":"sP ww","seasons":"sQ wB","genres":"sR wC","buttonWrapper":"sS wy","button":"sT wz"};